import { calc_gis_tooltip_style } from "@/utils/emap/common_point.js"

export const emit_station_data = function(id_prefix, sub_type) {
    return (options) => {
        this.gis_popup_type = sub_type;
        this.popup_type = 'gis_popup_data';
        const dom_id = `${id_prefix}${options.id}`
        this.gis_popup_data = {
            ...options,
            id: dom_id
        }
        this.gis_icon_style = {
            transform: `translate(-50%, -120%) ${calc_gis_tooltip_style(`#${dom_id}`)}`
        };
    }
}